import { useState } from "react";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../ey.json";
const ApiLoader = () => {
  const [hide, sethide] = useState(false)
  return (
    <>
      <div style={{ position: "fixed", width: '100vw', height: '100vh', zIndex: "999999", background: '#00000055', top: '0', left: "0", display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0px' }} onClick={() => sethide(true)}>
        <Lottie style={{ width: "260px" }} animationData={groovyWalkAnimation} />
      </div>
    </>
  );
};

export default ApiLoader;